import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import moment from 'moment'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Button } from "@material-ui/core";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import Add from "@material-ui/icons/AddBox";


import { formatStatus, prepareJobCardReports } from "../../../utils/helpers";
import { fetchProjectsRequest } from "../../../actions/project";
import { fetchCompaniesRequest } from "../../../actions/company";
import { fetchUsersRequest } from "../../../actions/users"
import { fetchJobCardsRequest } from "../../../actions/jobCard";
import { statuses } from "../../../utils/enums";
import SweetAlert from "react-bootstrap-sweetalert/lib/dist/SweetAlert";



class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openReportDialog: false,
      projectId: '',
      type: '',
      status: '',
      comapany: '',
      technician: '',
      inspector: '',
      startDate: '',
      endDate: '',
      openReportDialog: false,
      openErrorDialog: false,
      errorMessage: "There is no jobs for that selection"

    }
  }


  componentWillMount() {
    this.props.dispatch(fetchProjectsRequest());
    this.props.dispatch(fetchCompaniesRequest());
    this.props.dispatch(fetchUsersRequest());
    this.props.dispatch(fetchJobCardsRequest());

  }

  handleByJobType(event) {
    this.setState({
      type: event.target.value
    })
  }
  handleByJobStatus(event) {
    this.setState({
      status: event.target.value
    })
  }

  handleByProject(event) {
    this.setState({
      projectId: event.target.value
    })
  }
  handleByContractor(event) {
    this.setState({
      comapany: event.target.value
    })
  }
  handleByTechnician(event) {
    this.setState({
      technician: event.target.value
    })
  }

  handleByInspector(event) {
    this.setState({
      inspector: event.target.value
    })
  }
  resetSelection() {
    this.setState({
      projectId: '',
      type: '',
      status: '',
      comapany: '',
      technician: '',
      inspector: '',
      startDate: '',
      endDate: '',
    })
  }

  closeDialog() {
    this.resetSelection()
    this.setState({ openReportDialog: false })
  }

  filterJob() {
    let jobs = this.props.jobsData.jobCards

    const { projectId, status, type, comapany, technician, inspector, startDate, endDate } = this.state
    // console.log(jobs);

    if (startDate && endDate) {
      jobs = jobs.filter(x => this.isDateInRange(startDate, endDate, x.createdAt) === true)
    }


    if (type) {
      jobs = jobs.filter(x => x.type === formatStatus(type))
    }

    if (status) {
      jobs = jobs.filter(x => x.status === formatStatus(status))
    }

    if (projectId) {
      jobs = jobs.filter(x => x.project._id === projectId)
    }

    if (comapany) {
      jobs = jobs.filter((job, index) => {
        if (job.contractorCompany || job.inspectorCompany) {
          console.log(job.contractorCompany, comapany);
          
          return (job.contractorCompany ? job.contractorCompany._id : null) == comapany ||  
                 (job.inspectorCompany ? job.inspectorCompany._id : null) == comapany;
        }
      })
      console.log(jobs);
    }

    if (technician) {
      jobs = jobs.filter((job, index) => {
        if (job.technician) {
          return job.technician._id == technician._id;
        }
      })
    }

    if (inspector) {
      jobs = jobs.filter((job, index) => {
        if (job.inspector) {
          return job.inspector._id == inspector._id;
        }
      })
    }



    if (projectId || status || type || comapany || technician || inspector || (startDate && endDate)) {
      if (jobs.length === 0) {
        this.setState({ openErrorDialog: true })
      }else {
      prepareJobCardReports(jobs)
      }

    } else {
      this.setState({ openErrorDialog: true })
    }
    this.resetSelection()
  }

  isDateInRange(startDate, endDate, dateInput) {
    let date = moment(dateInput).format('YYYY-MM-DD')
    return date >= startDate && date <= endDate
  }

  dateHandlerStart(date) {
    const formatedDate = date.format('YYYY-MM-DD')
    this.setState({ startDate: formatedDate })
  }

  dateHandlerEnd(date) {
    const formatedDate = date.format('YYYY-MM-DD')
    this.setState({ endDate: formatedDate })
  }

  render() {

    const projects = this.props.projectData.projects || [];
    const jobTypes = this.props.configsData.configs ? this.props.configsData.configs.jobTypes : [];
    const companiesList = this.props.companyData.companies || [];
    const technicians = this.props.usersData.users ? this.props.usersData.users.filter(x => x.role === 'Technician') : []
    const inspectors = this.props.usersData.users ? this.props.usersData.users.filter(x => x.role === 'Inspector') : []
    const externalUser = this.props.loginData.AuthData ? this.props.loginData.AuthData.user.external : null;

    const dangerButtonStyle = {
      backgroundColor: "orange", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"
    }

    return (
      <div>
        {(!externalUser) ?
          <Button color="secondary" variant="contained" style={{ margin: "3px" }} onClick={() => this.props.history.push('/admin/create/jobcard')} >
            <Add />
            Create Job
            </Button> : ''}

        <Button color="secondary" variant="contained" onClick={() => this.setState({ openReportDialog: true })} >
          <SaveAlt />
          Download Report
            </Button>
        {this.state.openErrorDialog ? <SweetAlert
          warning
          showCancel
          showConfirm={false}
          style={{ display: "block", marginTop: "-100px" }}
          title="No jobs for that selection"
          onCancel={() => this.setState({ openErrorDialog: false })}
          cancelBtnStyle={dangerButtonStyle}
          cancelBtnText="Close"
        >
          Please make another selection
        </SweetAlert> : ''}
   
        <Dialog
          open={this.state.openReportDialog}

          onClose={() => { this.setState({ openReportDialog: false }) }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Job Reports</DialogTitle>
          <DialogContent>
            <GridContainer style={{ padding: "10px" }}>

              <GridItem xs={12} sm={6} md={6}>
                <Datetime
                  inputProps={{ placeholder: "Pick Start Date" }}
                  timeFormat={false}
                  name={this.state.startDate}
                  onChange={this.dateHandlerStart.bind(this)}
                  value={this.state.startDate || ""}
                  closeOnSelect={true}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={6} >
                <FormControl fullWidth>
                  <Datetime
                    inputProps={{ placeholder: "Pick End Date" }}
                    timeFormat={false}
                    name={this.state.endDate}
                    onChange={this.dateHandlerEnd.bind(this)}
                    value={this.state.endDate || ""}
                    closeOnSelect={true}

                  />
                </FormControl>
              </GridItem>

              <br />
              <br /> <br />
              <br />
              <br />
              <GridItem xs={12} sm={6} md={6}>
                <FormControl
                  fullWidth
                >
                  <InputLabel
                    htmlFor="simple-select"
                  >
                    By Job Type*
              </InputLabel>
                  <Select

                    value={this.state.type}
                    onChange={this.handleByJobType.bind(this)}
                    inputProps={{
                      name: "type",
                      id: "type"
                    }}
                  >
                    <MenuItem
                      disabled
                    >
                      Select Status
                </MenuItem>
                    {
                      jobTypes.map((type, index) =>
                        <MenuItem
                          key={index}

                          value={type}
                        >
                          {formatStatus(type)}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={6} md={6}>
                <FormControl
                  fullWidth
                >
                  <InputLabel
                    htmlFor="simple-select"
                  >
                    By Job Status*
              </InputLabel>
                  <Select

                    value={this.state.status}
                    onChange={this.handleByJobStatus.bind(this)}
                    inputProps={{
                      name: "type",
                      id: "type"
                    }}
                  >
                    <MenuItem
                      disabled
                    >
                      Select Job Type
                </MenuItem>
                    {
                      statuses.map((type, index) =>
                        <MenuItem
                          key={index}

                          value={type}
                        >
                          {formatStatus(type)}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>
              <br />
              <br />
              <br /> <br />
              <br />
              <GridItem xs={12} sm={6} md={6}>
                <FormControl
                  fullWidth
                >
                  <InputLabel
                    htmlFor="simple-select"
                  >
                    By Project*
              </InputLabel>
                  <Select

                    value={this.state.projectId}
                    onChange={this.handleByProject.bind(this)}
                    inputProps={{
                      name: "projectId",
                      id: "projectId"
                    }}
                  >
                    <MenuItem
                      disabled
                    >
                      Select Project
                </MenuItem>
                    {
                      projects.map((project, index) =>
                        <MenuItem

                          value={project._id}
                        >
                          {project.name}
                        </MenuItem>
                      )
                    }

                  </Select>
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={6} md={6} style={{ display: externalUser? 'none' : 'block'}}>
                <FormControl
                  fullWidth
                >
                  <InputLabel
                    htmlFor="simple-select"
                  >
                    By Contractor *
              </InputLabel>
                  <Select
                    value={this.state.comapany}
                    onChange={this.handleByContractor.bind(this)}
                    inputProps={{
                      name: "comapany",
                      id: "comapany"
                    }}
                  >
                    <MenuItem
                      disabled
                    >
                      Select Contractor
                </MenuItem>
                    {
                      companiesList.map((company, index) =>
                        <MenuItem
                          key={index}

                          value={company._id}
                        >
                          {formatStatus(company.comapanyName)}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>
              <br />
              <br />
              <br /> <br />
              <br />
              <GridItem xs={12} sm={6} md={6}>
                <FormControl fullWidth >
                  <InputLabel htmlFor="simple-select"> By Technician *  </InputLabel>
                  <Select

                    value={this.state.technician}
                    onChange={this.handleByTechnician.bind(this)}
                    inputProps={{
                      name: "technician",
                      id: "technician"
                    }}
                  >
                    <MenuItem disabled  >Select Technician </MenuItem>
                    {
                      technicians.map((technician, index) =>

                        <MenuItem
                          key={index}
                          value={technician}
                        >
                          {technician.firstName + " " + technician.lastName}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>

              </GridItem>


              <GridItem xs={12} sm={6} md={6}>
                <FormControl fullWidth >
                  <InputLabel htmlFor="simple-select"> By Inspector *  </InputLabel>
                  <Select
                    value={this.state.inspector}
                    onChange={this.handleByInspector.bind(this)}
                    inputProps={{
                      name: "inspector",
                      id: "inspector",
                    }}
                  >
                    <MenuItem disabled  >Select Inspector </MenuItem>
                    {
                      inspectors.map((inspector, index) =>

                        <MenuItem
                          key={index}

                          value={inspector}
                        >
                          {inspector.firstName + " " + inspector.lastName}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </GridItem>
              <br /><br /> <br /><br /> <br /><br />
            </GridContainer>

          </DialogContent>
          <DialogActions>
            <Button color="danger" variant="contained" onClick={this.closeDialog.bind(this)}>Close</Button>
            <Button color="primary" variant="contained" onClick={this.resetSelection.bind(this)}>Reset Selection</Button>
            <Button color="secondary" variant="contained" onClick={this.filterJob.bind(this)}>Download Report</Button>
            <br /><br />
          </DialogActions>
        </Dialog>


      </div>
    );
  }
}
export default withRouter(
  connect(state => ({
    configsData: state.appConfigState,
    projectData: state.projectState,
    companyData: state.companyState,
    usersData: state.usersState,
    jobsData: state.jobCardState,
    loginData: state.loginState

  }))(Reports)
);


// export default withRouter (comp_name);
